module.exports = __webpack_public_path__ + "img/hero-sp.eb5c14d5.jpg";